var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('insightReportAbundanceMeterBase',{attrs:{"dataItem":_vm.dataItem,"scale":_vm.scale,"chartId":_vm.chartId,"id":("abundance-meter-" + _vm.chartId)}}),_vm._v(" "),(_vm.enableTooltip)?_c('b-tooltip',{attrs:{"target":("abundance-meter-" + _vm.chartId)}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tooltipText)}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bed0c3f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@microbadevs/insight-report-abundance-meter/index.vue
// module id = HKln
// module chunks = 1